var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row bg-grey pt-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h3", { staticClass: "title-h3 border-bottom pb-3" }, [
            _c("button", {
              staticClass: "btn btn-back",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.$router.push("/customers")
                }
              }
            }),
            _vm._v("\n        Back\n      ")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row pt-3" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 text-right" }, [
          _vm.$_can("carriers.movers.invite")
            ? _c(
                "button",
                {
                  staticClass: "btn btn-primary ld-ext-right",
                  class: _vm.loadingButton ? "running" : "",
                  attrs: {
                    disabled: _vm.buttonDisabled || !_vm.emailsResend.length
                  },
                  on: { click: _vm.resendReviewRequests }
                },
                [
                  _vm._v("\n        RESEND REVIEW REQUESTS\n        "),
                  _c("div", { staticClass: "ld ld-ball ld-flip" })
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 l-m-b-20" }, [
          _c("div", { staticClass: "input-group search" }, [
            _c(
              "button",
              {
                staticClass: "btn input-group-btn",
                attrs: { type: "button" },
                on: { click: _vm.clearSearch }
              },
              [_c("i", { class: [_vm.q ? "fa fa-remove" : "fa fa-search"] })]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.q,
                  expression: "q"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", placeholder: "Search" },
              domProps: { value: _vm.q },
              on: {
                keyup: function($event) {
                  _vm.searchText($event)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.q = $event.target.value
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-11 filters-field" }, [
          _c("span", [_vm._v("Filters:")]),
          _vm._v(" "),
          _vm.filters.company
            ? _c("span", { staticClass: "filter-item btn btn-filter" }, [
                _c("span", {
                  staticClass: "mod-icon-filter",
                  on: {
                    click: function($event) {
                      _vm.removeFilter("company")
                    }
                  }
                }),
                _vm._v(
                  "\n        Company: " +
                    _vm._s(
                      _vm.companies.find(function(el) {
                        return el.id === _vm.filters.company
                      }).name
                    )
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.filters.used
            ? _c("span", { staticClass: "filter-item btn btn-filter" }, [
                _c("span", {
                  staticClass: "mod-icon-filter",
                  on: {
                    click: function($event) {
                      _vm.removeFilter("used")
                    }
                  }
                }),
                _vm._v(
                  "\n        Used: " +
                    _vm._s(_vm.filters.used === 1 ? "Link Used" : "Not Used")
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary add-filters",
              on: {
                click: function($event) {
                  _vm.showFilters = true
                }
              }
            },
            [_c("i", { staticClass: "fa fa-plus filter-icon" })]
          )
        ])
      ]),
      _vm._v(" "),
      !_vm.requestedReviews
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c("table", { staticClass: "table m-table table-hover l-m-t-20" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.requestedReviews, function(review, index) {
                    return _c("tr", { key: review.id }, [
                      _c("td", [
                        _vm._v(
                          _vm._s(review.first_name) +
                            " " +
                            _vm._s(review.last_name)
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(review.email))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(review.company.name))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(review.used ? "Link Used" : "Not Used"))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "py-0 align-baseline" }, [
                        _c("div", { staticClass: "check-field" }, [
                          _c(
                            "label",
                            {
                              class: {
                                "check-open": _vm.emailsResend.find(function(
                                  el
                                ) {
                                  return el === review.id
                                })
                              },
                              attrs: { for: index }
                            },
                            [
                              _c("span", { staticClass: "checkmark" }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.emailsResend,
                                    expression: "emailsResend"
                                  }
                                ],
                                staticClass: "btn-check",
                                attrs: { type: "checkbox", id: index },
                                domProps: {
                                  value: review.id,
                                  checked: Array.isArray(_vm.emailsResend)
                                    ? _vm._i(_vm.emailsResend, review.id) > -1
                                    : _vm.emailsResend
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.emailsResend,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = review.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.emailsResend = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.emailsResend = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.emailsResend = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  !_vm.requestedReviews.length
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: "8" }
                          },
                          [_vm._v("\n            No results found\n          ")]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              [
                _vm.meta.total
                  ? _c("div", { staticClass: "col-sm-6 mb-1 text-black-50" }, [
                      _vm._v(
                        "\n        Showing " +
                          _vm._s(_vm.meta.from) +
                          " - " +
                          _vm._s(_vm.meta.to) +
                          " of " +
                          _vm._s(_vm.meta.total) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "col-sm-6 mb-1",
                  attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                })
              ],
              1
            )
          ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _vm.showFilters
                  ? _c(
                      "div",
                      { staticClass: "filters-side-modal flex flex-column" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function($event) {
                                _vm.showFilters = !_vm.showFilters
                              }
                            }
                          },
                          [
                            _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                              _c("span", { staticClass: "btn btn-back" }),
                              _vm._v("Add Filter")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              "\n            Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "l-bg-white" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("div", { staticClass: "row filters" }, [
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Company")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.companies,
                                          placeholder: "Select Company"
                                        },
                                        on: { input: _vm.filter },
                                        model: {
                                          value: _vm.filters.company,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "company",
                                              $$v
                                            )
                                          },
                                          expression: "filters.company"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Used")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: { options: _vm.usedOptions },
                                        on: { input: _vm.filter },
                                        model: {
                                          value: _vm.filters.used,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "used", $$v)
                                          },
                                          expression: "filters.used"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-auto" }, [
                          _c("div", { staticClass: "col" }, [
                            !(!_vm.filters.used && !_vm.filters.company)
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-not-active text-dark w-100",
                                    attrs: { type: "button" },
                                    on: { click: _vm.clearFilters }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Clear filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6 l-m-b-20" }, [
      _c("h1", [_vm._v("Requested Reviews")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "m-table__heading" }, [
      _c("tr", [
        _c("th", [_vm._v("\n            Customer\n          ")]),
        _vm._v(" "),
        _c("th", [_vm._v("\n            Email\n          ")]),
        _vm._v(" "),
        _c("th", [_vm._v("\n            Company\n          ")]),
        _vm._v(" "),
        _c("th", [_vm._v("\n            Used\n          ")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c757cba8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c757cba8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/customers/CustomersPending.vue
// module id = null
// module chunks = 